module.exports = "\r\n  <div class=\"form-group\">\r\n    <label>Shop name:</label>\r\n    <input #shopName class=\"form-control\">\r\n  </div>\r\n  <div class=\"form-group\">\r\n    <label for=\"users\">Owner:</label>\r\n    <select  class=\"form-control\" #shopOwner>\r\n      <option *ngFor=\"let currentUser of childUserList\">{{currentUser.name}}</option>\r\n    </select>\r\n  </div>\r\n  <button class=\"btn\" (click)=\"submitShopForm(shopOwner.value, shopName.value)\">Submit</button>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/sara/epicodus/quasi-etsy/src/app/new-shop/new-shop.component.html
// module id = ../../../../../src/app/new-shop/new-shop.component.html
// module chunks = main